
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/sentry.client.config.ts")
            }
          });